import { Component, input } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormField, MatLabel } from '@angular/material/form-field';

@Component({
    selector: 'unite-income-source-field',
    templateUrl: './income-source-field.component.html',
    styleUrls: ['./income-source-field.component.scss'],
    imports: [MatFormField, MatLabel, TranslateModule, MatSelect, ReactiveFormsModule, MatOption]
})
export class IncomeSourceFieldComponent {

  control = input<FormControl>();
  classField = input('');

  editIcon = input(false);
  checkIcon = input(true);


  onEnter(event: KeyboardEvent) {
    (<HTMLInputElement>event.target).blur();
  }
}
